import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a7b7cc1"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onSubmit"];
const _hoisted_2 = { class: "group" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "highlight" }, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "bar" }, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Email", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    type: "submit",
    class: "submit"
}, "Register", -1));
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import FormWrapper from '@/components/FormWrapper.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FooterLoginForm',
    setup(__props) {
        const router = useRouter();
        const email = ref('');
        function redirectToSignup() {
            router.push({
                name: 'Signup',
                query: {
                    email: email.value
                }
            });
            email.value = '';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "center-start",
                onSubmit: _withModifiers(redirectToSignup, ["prevent"])
            }, [
                _createVNode(FormWrapper, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _withDirectives(_createElementVNode("input", {
                                id: "footer-email",
                                type: "email",
                                class: _normalizeClass({ used: email.value !== '' }),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                                title: "Enter your account email address",
                                autofocus: "",
                                required: ""
                            }, null, 2), [
                                [_vModelText, email.value]
                            ]),
                            _hoisted_3,
                            _hoisted_4,
                            _hoisted_5
                        ])
                    ]),
                    _: 1
                }),
                _hoisted_6
            ], 40, _hoisted_1));
        };
    }
});
